import CreateAccount from "@/pages/auth/CreateAccount";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import Login from "@/pages/auth/Login";
import ResetCode from "@/pages/auth/ResetCode";
import ResetPassword from "@/pages/auth/ResetPassword";
import ResetPasswordSuccess from "@/pages/auth/ResetPasswordSuccess";
import TwoFA from "@/pages/auth/TwoFA";
import VerifyEmail from "@/pages/auth/VerifyEmail";
import { Route, Routes } from "react-router";

const Auth = () => {
  return (
    <Routes>
      <Route index path={"/"} element={<Login />} />
      <Route index path={"/create-account"} element={<CreateAccount />} />
      <Route index path={"/VerifyEmail"} element={<VerifyEmail />} />
      <Route path={"/2fa-auth"} element={<TwoFA />} />
      <Route path={"/forgot-password"} element={<ForgotPassword />} />
      <Route path={"/reset-code"} element={<ResetCode />} />
      <Route path={"/reset-password"} element={<ResetPassword />} />
      <Route path={"/reset-successful"} element={<ResetPasswordSuccess />} />
    </Routes>
  );
};

export default Auth;
